<template>
  <div class="contact">
    <div class="top">
      <img src="../image/logo.png" alt="" class="loGo">
      <el-row class="tac">
                <el-col :span="12">
                    <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
                        active-text-color="#ffd04b" :unique-opened="true">
                        <el-submenu index="1">
                            <template slot="title">
                                <img src="../image/menu.png" alt="" class="logo-1">
                            </template>
                            <el-menu-item-group>
                                <template v-for="(menu, index) in navList">
                                    <el-menu-item :index="`1-${index + 1}`" v-if="menu.children.length == 0"
                                        :key="menu.index">
                                        <router-link :to="menu.route" class="linkclass">
                                            {{ menu.name }}
                                        </router-link>
                                    </el-menu-item>
                                    <el-submenu :index="`1-${index + 1}`" v-if="menu.children.length !== 0" :key="menu.index">
                                        <template slot="title">{{ menu.name }}</template>
                                        <el-menu-item v-for="(subMenu, subIndex) in menu.children"
                                            :index="`1-${index + 1}-${subIndex + 1}`" :key="subMenu.index">
                                            <router-link :to="subMenu.route" class="linkclass">{{ subMenu.name
                                            }}</router-link>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </el-menu-item-group>

                        </el-submenu>
                    </el-menu>
                </el-col>
            </el-row>
      <!--  -->
      <div class="links">
        <span class="links-1"><router-link to="/qualifications" class="links-1-1">公司资质</router-link></span>
        <span class="links-2">联系我们</span>
      </div>
    </div>
    <div class="contact-we">
      <div class="cw">
        <div class="cw-1">
          <span style="color: #014F93;">联系我们</span>
          <span>CONTACT US</span>
          <p>如果您对我公司有建议或反馈，<br>请在此页面填写相关信息并提交，<br>会有工作人员及时与您联系<br>或请直接拨打我们的电话</p>
        </div>
        <div class="cw-2">
          <span>合作热线</span>
          <p>173-2304-3386</p>
          <span class="cw-2-1">四川省成都市双流区剑南大道南段华宜·上锦210</span>
        </div>
      </div>
      <div class="information">
        <span>在线咨询</span>
        <input type="text" placeholder="请输入姓名" v-model="name">
        <input type="number" placeholder="请输入手机号" v-model="phone" class="middle-1-2"
          oninput="if( this.value.length > 11 )  this.value = this.value.slice(0,11)" id="myinput">
        <input type="text" placeholder="请输入电子邮箱" v-model="email">
        <input type="text" placeholder="请输入咨询的内容" v-model="demand">
        <button :plain="true" @click="messages">立即提交</button>
      </div>
    </div>
    <BUTTOM></BUTTOM>
  </div>
</template>

<script>
import {api_save_leave,api_category} from '../APi/api';
export default {
  data() {
    return {
      name: "",
      phone: "",
      demand: "",
      email: "",
      navList:[],
    };
  },
  methods: {
    messages() {
      if (this.name == '') {
        this.$message({
          message: "请输入姓名",
          type: "error",
        });
        return
      }
      if (this.phone == '') {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "error",
        });
        return
      }
      if (this.email == '') {
        this.$message({
          message: "请输入您的电子邮箱",
          type: "error",
        });
        return
      }
      if (this.demand == '') {
        this.$message({
          message: "请输入您想咨询的内容",
          type: "error",
        });
        return
      }
      api_save_leave({
        name: this.name,
        phone: this.phone,
        demand: this.demand,
        email:this.email,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          (this.name = ""), (this.phone = ""), (this.demand = ""),(this.email="");
        }else {
          this.$message.error("提交失败");
        }
      });
    },
    handleScroll() {
      const nav = document.querySelector('.tac'); // 导航栏元素
      const distanceFromTop = nav.offsetTop; // 导航栏距离顶部的距离

      if (window.pageYOffset > distanceFromTop) { // 当滚动距离超过导航栏距离顶部的距离时
        nav.classList.add('fixed'); // 添加固定样式类
      } else {
        nav.classList.remove('fixed'); // 移除固定样式类
      }
    },
    // 获取栏目列表
    getCategory() {
            api_category().then((res) => {
                this.navList = res.data;
                // console.log(this.navList)
            });
        },
  },
  created() {
        this.getCategory();
    },
  mounted() {
    if (!sessionStorage.getItem('isRefreshed')) {
      sessionStorage.setItem('isRefreshed', true);
      window.location.reload();
    } else {
      sessionStorage.removeItem('isRefreshed');
    }
    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
// 导航菜单
::v-deep .el-row {
  width: 13rem;
}

::v-deep .el-submenu {
  width: 13rem;
}

::v-deep .el-col-12 {
  width: 100%;
}

::v-deep .el-menu {
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

::v-deep .el-submenu .el-menu-item {
  color: white;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

::v-deep .el-submenu__title {
  color: white;
  background-color: transparent !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

::v-deep .el-icon-arrow-down:before {
  color: white;
}

::v-deep .el-submenu .el-menu-item {
  background-color: transparent !important;
}

::v-deep .el-menu {
  background-color: transparent !important;
}

.tac {
  z-index: 2;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
}

::v-deep .el-menu-item-group>ul {
  height: 44rem;
}

.tac.fixed {
  position: fixed;
  right: 0;
}

.linkclass {
  text-decoration: none;
  color: white;
}

// 
.contact {
  .top {
    width: 100%;
    height: 15.13rem;
    background-image: url(../image/zz-8.png);
    background-size: 100% 100%;

    .loGo {
      width: 8.13rem;
      height: 2.51rem;
      margin-left: 5.81rem;
    }

    .logo-1 {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 5.81rem;
    }
  }

  .links {
    width: 15rem;
    height: 4.38rem;
    font-size: 1.13rem;
    color: #FFFFFF;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding-top: 2rem;
    margin: 0 auto;

    .links-1-1 {
      color: white;
      text-decoration: none;
    }

    .links-2 {
      background-color: white;
      color: #014F93;
    }

    span {
      width: 7.13rem;
      height: 4.38rem;
      text-align: center;
      line-height: 4.38rem;
      cursor: pointer;
      cursor: zoom-in;
      transition: font-size 0.2s ease-in-out;
    }

    span:hover {
      font-size: 1.2em;
      cursor: pointer;
    }
  }

  .contact-we {
    width: 70rem;
    height: 23rem;
    margin: 0 auto;
    margin-top: 4.75rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 19.5rem;

    .cw {
      width: 19rem;
      height: 23rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .cw-1 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 2rem;

        span {
          font-size: 1.13rem;
          font-weight: 600;
        }
      }

      .cw-2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 2.5rem;

        .cw-2-1 {
          font-size: 0.88rem;
          font-weight: 400;
          color: #000;
        }

        span {
          font-size: 1.13rem;
          font-weight: 600;
          color: #014F93;
        }

        p {
          font-size: 1.38rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
      }
    }

    .information {
      width: 45.73rem;
      height: 23rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;

      span {
        font-size: 1.13rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #014F93;
      }

      input {
        width: 44.53rem;
        height: 3.13rem;
        border-radius: 0.06rem;
        border: 0.06rem solid #DBDBDB;
        padding: 0 0.6rem;
      }

      .middle-1-2::-webkit-inner-spin-button,
      .middle-1-2::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input:focus {
        outline: none;
      }

      button {
        width: 100%;
        height: 3.13rem;
        background: #014F93;
        border-radius: 0.06rem;
        color: #DBDBDB;
        font-size: 0.88rem;
        border: 0.06rem solid #014F93;
      }
    }
  }
}
// 移动端 
@media screen and (max-width: 900px) {
  // 移动
  ::v-deep .el-row {
  width: 8.5rem;
}
::v-deep .el-row {
  width: 8.5rem;
}

::v-deep .el-submenu {
  width: 8.5rem;
}

::v-deep .el-col-12 {
  width: 100%;
}

::v-deep .el-menu {
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

::v-deep .el-submenu .el-menu-item {
  color: white;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

::v-deep .el-submenu__title {
  width: 8.5rem;
  color: white;
  background-color: transparent !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

::v-deep .el-icon-arrow-down:before {
  color: white;
}

::v-deep .el-submenu .el-menu-item {
  background-color: transparent !important;
}

::v-deep .el-menu {
  background-color: transparent !important;
}

.tac {
  width: 35%;
  z-index: 2;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
}

::v-deep .el-menu-item-group>ul {
  height: 49rem;
}

.tac.fixed {
  position: fixed;
  right: 0;
}

.linkclass {
  text-decoration: none;
  color: white;
}

// 
.contact {
  .top {
    width: 100%;
    height: 15.13rem;
    background-image: url(../image/zz-8.png);
    background-size: 100% 100%;

    .loGo {
      width: 8.13rem;
      height: 2.51rem;
      margin-left: 0rem;
      margin-top: 0.5rem;
    }

    .logo-1 {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 5.81rem;
    }
  }

  .links {
    width: 15rem;
    height: 4.38rem;
    font-size: 1.13rem;
    color: #FFFFFF;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding-top: 2rem;
    margin: 0 auto;

    .links-1-1 {
      color: white;
      text-decoration: none;
    }

    .links-2 {
      background-color: white;
      color: #014F93;
    }

    span {
      width: 7.13rem;
      height: 4.38rem;
      text-align: center;
      line-height: 4.38rem;
      cursor: pointer;
      cursor: zoom-in;
      transition: font-size 0.2s ease-in-out;
    }

    span:hover {
      font-size: 1.2em;
      cursor: pointer;
    }
  }

  .contact-we {
    width: 100%;
    height: 42rem;
    margin: 0 auto;
    margin-top: 4.75rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10rem;

    .cw {
      width: 95%;
    height: 23rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin: auto;

      .cw-1 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 2rem;

        span {
          font-size: 1.13rem;
          font-weight: 600;
        }
      }

      .cw-2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 2.5rem;

        .cw-2-1 {
          font-size: 0.88rem;
          font-weight: 400;
          color: #000;
        }

        span {
          font-size: 1.13rem;
          font-weight: 600;
          color: #014F93;
        }

        p {
          font-size: 1.38rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
      }
    }

    .information {
      width: 100%;
    height: 23rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

      span {
        width: 95%;
        margin: auto;
        font-size: 1.13rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #014F93;
      }

      input {
        width: 90%;
        margin: auto;
        height: 3.13rem;
        border-radius: 0.06rem;
        border: 0.06rem solid #DBDBDB;
        padding: 0 0.6rem;
      }

      .middle-1-2::-webkit-inner-spin-button,
      .middle-1-2::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input:focus {
        outline: none;
      }

      button {
        width: 95%;
        height: 3.13rem;
        background: #014F93;
        border-radius: 0.06rem;
        color: #DBDBDB;
        font-size: 0.88rem;
        border: 0.06rem solid #014F93;
        margin: auto  ;
      }
    }
  }
}
}
</style>